import { render, staticRenderFns } from "./ModalAlterarDados.vue?vue&type=template&id=7e75f8af"
import script from "./ModalAlterarDados.vue?vue&type=script&lang=js"
export * from "./ModalAlterarDados.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports